const TAG_ALIAS = { b: "strong", i: "em" };
const ALLOWED_OPEN = new Set(["strong", "em", "u", "a", "p", "br"]);
const HREF_RE = /href\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s>]+))/i;
const TAG_NAME_RE = /^([a-zA-Z][\w-]*)/;

function escapeAttr(value) {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll("\"", "&quot;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;");
}

function isSafeHref(href) {
  const trimmed = href.trim();
  if (!trimmed) return false;
  if (trimmed.startsWith("/") || trimmed.startsWith("#")) return true;
  return /^https?:\/\//i.test(trimmed);
}

function toInputString(input) {
  if (input == null) return "";
  if (typeof input === "string") return input;
  if (typeof input === "number" || typeof input === "boolean") return String(input);
  return "";
}

function normalizeTag(tag) {
  const lower = tag.toLowerCase();
  return TAG_ALIAS[lower] || lower;
}

function rewriteAnchor(attrs) {
  const hrefMatch = HREF_RE.exec(attrs);
  const href = hrefMatch ? (hrefMatch[1] ?? hrefMatch[2] ?? hrefMatch[3] ?? "") : "";
  if (!isSafeHref(href)) return "";
  return `<a href="${escapeAttr(href.trim())}" target="_blank" rel="noopener noreferrer">`;
}

function renderTag(tag, isClose, body, rawName) {
  if (tag === "br") return "<br>";
  if (tag === "a" && !isClose) return rewriteAnchor(body.slice(rawName.length));
  if (isClose) return `</${tag}>`;
  return `<${tag}>`;
}

function advancePastComment(source, open) {
  const endComment = source.indexOf("-->", open + 4);
  return endComment === -1 ? source.length : endComment + 3;
}

function consumeMarkup(source, open) {
  if (source.startsWith("<!--", open))
    return { html: "", next: advancePastComment(source, open), done: false };

  const close = source.indexOf(">", open + 1);
  if (close === -1) return { html: source.slice(open), next: source.length, done: true };

  const raw = source.slice(open + 1, close).trim();
  const isClose = raw.startsWith("/");
  const body = isClose ? raw.slice(1).trim() : raw;
  const nameMatch = TAG_NAME_RE.exec(body);
  if (!nameMatch) return { html: "", next: close + 1, done: false };

  const tag = normalizeTag(nameMatch[1]);
  if (!ALLOWED_OPEN.has(tag)) return { html: "", next: close + 1, done: false };

  return {
    html: renderTag(tag, isClose, body, nameMatch[1]),
    next: close + 1,
    done: false,
  };
}

export function sanitizeNotificationHtml(input) {
  const source = toInputString(input);
  if (!source) return "";

  let out = "";
  let index = 0;
  while (index < source.length) {
    const open = source.indexOf("<", index);
    if (open === -1) return out + source.slice(index);
    out += source.slice(index, open);
    const step = consumeMarkup(source, open);
    out += step.html;
    if (step.done) return out;
    index = step.next;
  }
  return out;
}
